import { render, staticRenderFns } from "./userMy_toolsAttr.vue?vue&type=template&id=bce18470&scoped=true"
import script from "./userMy_toolsAttr.vue?vue&type=script&lang=js"
export * from "./userMy_toolsAttr.vue?vue&type=script&lang=js"
import style0 from "./userMy_toolsAttr.vue?vue&type=style&index=0&id=bce18470&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bce18470",
  null
  
)

component.options.__file = "userMy_toolsAttr.vue"
export default component.exports